import { SupplierModel, type Supplier } from '@/http/models/PosCatalog'

import { Badge } from '@/components/ui/badge'

import { ResourcePage } from '@/components/features/pos/ResourcePage'

const Suppliers = () => (
  <ResourcePage<Supplier>
    title="Suppliers"
    description="Who you buy stock from."
    noun="supplier"
    api={SupplierModel}
    permissions={{ create: 'suppliers:create', update: 'suppliers:update', delete: 'suppliers:delete' }}
    searchPlaceholder="Search by name"
    columns={[
      { label: 'Name', render: (s) => <span className="font-medium text-ink">{s.name}</span> },
      { label: 'Contact', render: (s) => s.contact_person || '—', className: 'hidden md:table-cell' },
      { label: 'Phone', render: (s) => s.contact_number || '—' },
      { label: 'Email', render: (s) => s.email || '—', className: 'hidden md:table-cell' },
      { label: 'Status', render: (s) => <Badge tone={s.status === 'active' ? 'success' : 'soft'}>{s.status === 'active' ? 'Active' : 'Inactive'}</Badge> },
    ]}
    fields={[
      { name: 'name', label: 'Name', type: 'text', required: true },
      { name: 'contact_person', label: 'Contact person', type: 'text' },
      { name: 'contact_number', label: 'Phone', type: 'text' },
      { name: 'email', label: 'Email', type: 'email' },
      { name: 'address', label: 'Address', type: 'textarea' },
      { name: 'status', label: 'Active', type: 'status' },
    ]}
    toForm={(s) => ({
      name: s?.name ?? '',
      contact_person: s?.contact_person ?? '',
      contact_number: s?.contact_number ?? '',
      email: s?.email ?? '',
      address: s?.address ?? '',
      status: (s?.status ?? 'active') === 'active',
    })}
  />
)

export default Suppliers
